import { ComponentRendererProps } from "@/store/sagas/types/deviceUnlock";
import SectionRenderer from "./SectionRenderer";


const DeviceStatusRenderer: React.FC<ComponentRendererProps> = ({ component, onSubmit, onNavigate }) => {
  const isSuccess = component.details.status === 'ELIGIBLE';
  const isError = component.details.status === 'NOT_ELIGIBLE';

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className={`p-6 rounded-lg border-2 ${
        isSuccess ? 'border-green-200 bg-green-50' : 
        isError ? 'border-red-200 bg-red-50' : 
        'border-gray-200 bg-gray-50'
      }`}>
        <h1 className="text-2xl font-bold mb-4">{component.details.title}</h1>
        <p className="text-gray-700 mb-6">{component.details.body}</p>
        
        {component.details.deviceInfo && (
          <div className="bg-white p-4 rounded-lg mb-6">
            <h3 className="font-semibold mb-2">Device Information</h3>
            <p><strong>IMEI:</strong> {component.details.deviceInfo.imei}</p>
            {component.details.deviceInfo.model && (
              <p><strong>Model:</strong> {component.details.deviceInfo.model}</p>
            )}
            {component.details.deviceInfo.remainingDays && (
              <p><strong>Days Remaining:</strong> {component.details.deviceInfo.remainingDays}</p>
            )}
          </div>
        )}

        <div className="space-y-4">
          {component.details.content.section.map((section) => (
            <SectionRenderer 
              key={section.id} 
              section={section} 
              onSubmit={onSubmit}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default DeviceStatusRenderer;